import { useSelector } from 'react-redux'
import { IconShape } from 'types/embed'

const useWidgetIconShape = (): IconShape => {
    return useSelector(state => (
        state.embed.configuration.theme.widgetIconShape
    )) || IconShape.SQUARE
}

export default useWidgetIconShape
